var HomeComponent = /** @class */ (function () {
    function HomeComponent() {
    }
    return HomeComponent;
}());
export { HomeComponent };



// WEBPACK FOOTER //
// ./src/app/page/home/home.component.ts.pre-build-optimizer.js